import React from "react";
import { GradientDivider, WaveDivider } from "../components/UI";
import GradientSection from "../components/GradientSection";
import PageLayout from "../components/PageLayout";
import RaceCalendar from "../components/RaceCalendar";
import { getGradientClass } from "../constants/theme";
import { SITE_URL } from "../constants/site";
import { raceYear, upcomingRaces } from "../data/races";

export default function Races() {
    return (
        <PageLayout
            seo={{
                title: "Bike Races in Missoula - Osprey Racing Team Schedule 2026",
                description:
                    "Osprey Racing Team race schedule for 2026. Bike races in Montana, Idaho, and the Pacific Northwest. Gravel, road, and cyclocross events.",
                url: `${SITE_URL}/races`,
                image: "/img/westRace.jpeg",
            }}
            title={`${raceYear} Race Calendar`}
            subtitle="Click the calendar to expand and view race dates"
        >
            <GradientDivider />
            <WaveDivider />

            <div className="mb-16">
                <RaceCalendar races={upcomingRaces} />
            </div>

            <GradientSection>
                <h2 className="text-3xl font-bold mb-8 text-sky-400 text-center">All {raceYear} Races</h2>
                <div className="grid md:grid-cols-2 gap-6">
                    {upcomingRaces.map((race, index) => (
                        <div
                            key={race.id}
                            className={`bg-gradient-to-br ${getGradientClass(index)} p-0.5 rounded-lg hover:scale-105 transition-transform duration-200`}
                        >
                            <div className="bg-gray-800 rounded-lg p-6 h-full">
                                <h3 className="text-xl font-bold mb-2 text-white">{race.name}</h3>
                                <div className="text-gray-300 space-y-1">
                                    <p>
                                        <span className="text-sky-400 font-semibold">Date: </span>
                                        {race.dateObj?.toLocaleDateString("en-US", {
                                            month: "long",
                                            day: "numeric",
                                        }) || race.date}
                                    </p>
                                    <p>
                                        <span className="text-yellow-400 font-semibold">Location: </span>
                                        {race.location}
                                    </p>
                                    <p>
                                        <span className="text-pink-400 font-semibold">Vibe: </span>
                                        {race.vibe}
                                    </p>
                                    {race.result && (
                                        <p className="mt-2">
                                            <span className="text-yellow-400 font-bold">Result: </span>
                                            <span className="text-white">{race.result}</span>
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </GradientSection>

            <GradientDivider />
        </PageLayout>
    );
}
